import lighthouseMark from "./faro-lighthouse.svg";

export function FaroLighthouseMark(props: { class?: string; size?: number }) {
  return (
    <img
      class={props.class}
      src={lighthouseMark}
      width={props.size}
      height={props.size}
      alt=""
      aria-hidden="true"
    />
  );
}
